import * as ng from 'angular';
import {PreviewService} from '../../../../services/preview.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {appContext} from '../../../../app.context';

class RequestInformationConservazioneController implements ng.IController {

  static $inject: string[] = [
    '$rootScope',
    '$scope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    '$sce',
    '$uibModal',
    '$parse'
  ];

  constructor(
    private $rootScope: any,
    private $scope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $parse: ng.IParseService
  ) {
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');

    if ($scope.user === undefined) {
      $scope.user = store.get('user');
    }

    let init = () => {
      if ($scope.user !== undefined) {
        if ($scope.user.accountData.userType === 1) {
          $state.go('home.request-information-conservazione');
          return;
        }
      } else {
        setTimeout(init, 1000);
      }
    };
    init();
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };
    $scope.refreshBirthCountries = () => {
      ArchiSmallServices.getTypeaheadValues('country')
        .then((response: any) => {
          $scope.birthCountries = response;
        }, (error) => {
          $rootScope.alert('error', error);

        });
    };
    $scope.refreshBirthStates = () => {
      let country = $scope.user.organizationData.contactPerson.birthCountry === '' ? 'Italy' : $scope.user.organizationData.contactPerson.birthCountry;
      ArchiSmallServices.getTypeaheadValues('state', 'country=' + country)
        .then((response: any) => {
          $scope.birthStates = response;
        }, (error) => {
          $rootScope.alert('error', error);

        });
    };
    $scope.refreshBirthCities = () => {
      let country = $scope.user.organizationData.contactPerson.birthCountry;
      let state = $scope.user.organizationData.contactPerson.birthProvince;
      ArchiSmallServices.getTypeaheadValues('municipality', 'country=' + country + '&state=' + state)
        .then((response: any) => {
          $scope.birthCities = response;
        }, (error) => {
          $rootScope.alert('error', error);

        });
    };
    $scope.refreshBirthStates();
    $scope.refreshBirthCities();
    $scope.refreshBirthCountries();
    // <editor-fold desc='openConfermaModal'>
    $scope.openConfermaModal = (size) => {

      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'conservazioneConfermaComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
    };
    $scope.formsubmitted = false;
    $scope.emptyIfFieldChanged = (dependentModel1, dependentModel2, dependentModel3) => {
      $parse(dependentModel1).assign($scope, '');
      if (dependentModel2) {
        $parse(dependentModel2).assign($scope, '');
      }
      if (dependentModel3) {
        $parse(dependentModel3).assign($scope, '');
      }
    };
    // </editor-fold>

    // <editor-fold desc='DatePicker'>

    $scope.dpOpened = {
      birthDate: false
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:disable:no-string-literal */
    $scope.autoOpen = ($event, opened) => {

      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:enable:no-string-literal */
    // </editor-fold>

  }
}

export const RequestInformationConservazioneComponent: ng.IComponentOptions = {
  template: require('./request-information-conservazione.html'),
  controller: RequestInformationConservazioneController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/request-information-conservazione/request-information-conservazione.ts